// calibrationLogsList/calibrationLogsListActions.js

import { getCalibrationLogBooks } from "../../api/CalibrationLogsApi";
import { calibrationLogsListInitialState } from "./calibrationLogsListState";

export const makeCalibrationLogsListActions = (set, get) => ({
  setActiveListPage: (page) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        active: {
          ...s.calibrationLogsList.active,
          pagination: {
            ...s.calibrationLogsList.active.pagination,
            currentPage: page,
          },
        },
      },
    })),

  setActiveBooksPerPage: (perPage) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        active: {
          ...s.calibrationLogsList.active,
          pagination: {
            ...s.calibrationLogsList.active.pagination,
            booksPerPage: perPage,
            currentPage: 1,
          },
        },
      },
    })),

  setSelectedActiveCalibrationLogBook: (book) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        active: {
          ...s.calibrationLogsList.active,
          selectedId: book?.id || null,
        },
      },
    })),

  fetchActiveCalibrationLogBooksPage: async (filters) => {
    const {
      calibrationLogsList: {
        active: {
          pagination: { currentPage, booksPerPage },
        },
      },
    } = get();

    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        active: { ...s.calibrationLogsList.active, isLoading: true, error: null },
      },
    }));

    try {
      const response = await getCalibrationLogBooks(
        "active",
        currentPage,
        booksPerPage,
        filters
      );
      const { calibration_log_books, pagination } = response.data || {};
      set((s) => ({
        calibrationLogsList: {
          ...s.calibrationLogsList,
          active: {
            ...s.calibrationLogsList.active,
            isLoading: false,
            items: calibration_log_books || [],
            pagination: pagination
              ? {
                  currentPage: pagination.page,
                  totalPages: pagination.pages,
                  totalBooks: pagination.total,
                  booksPerPage: pagination.per_page,
                }
              : s.calibrationLogsList.active.pagination,
          },
        },
      }));
      return { ok: true };
    } catch (err) {
      console.error("Failed to fetch calibration log books page:", err);
      set((s) => ({
        calibrationLogsList: {
          ...s.calibrationLogsList,
          active: {
            ...s.calibrationLogsList.active,
            isLoading: false,
            error: err?.message || "Failed to load calibration log books",
          },
        },
      }));
      return { ok: false, error: err };
    }
  },

  setCompletedListPage: (page) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        completed: {
          ...s.calibrationLogsList.completed,
          pagination: {
            ...s.calibrationLogsList.completed.pagination,
            currentPage: page,
          },
        },
      },
    })),

  setCompletedBooksPerPage: (perPage) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        completed: {
          ...s.calibrationLogsList.completed,
          pagination: {
            ...s.calibrationLogsList.completed.pagination,
            booksPerPage: perPage,
            currentPage: 1,
          },
        },
      },
    })),

  setSelectedCompletedCalibrationLogBook: (book) =>
    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        completed: {
          ...s.calibrationLogsList.completed,
          selectedId: book?.id || null,
        },
      },
    })),

  fetchCompletedCalibrationLogBooksPage: async (filters) => {
    const {
      calibrationLogsList: {
        completed: {
          pagination: { currentPage, booksPerPage },
        },
      },
    } = get();

    set((s) => ({
      calibrationLogsList: {
        ...s.calibrationLogsList,
        completed: {
          ...s.calibrationLogsList.completed,
          isLoading: true,
          error: null,
        },
      },
    }));

    try {
      const response = await getCalibrationLogBooks(
        "completed",
        currentPage,
        booksPerPage,
        filters
      );
      const { calibration_log_books, pagination } = response.data || {};
      set((s) => ({
        calibrationLogsList: {
          ...s.calibrationLogsList,
          completed: {
            ...s.calibrationLogsList.completed,
            isLoading: false,
            items: calibration_log_books || [],
            pagination: pagination
              ? {
                  currentPage: pagination.page,
                  totalPages: pagination.pages,
                  totalBooks: pagination.total,
                  booksPerPage: pagination.per_page,
                }
              : s.calibrationLogsList.completed.pagination,
          },
        },
      }));
      return { ok: true };
    } catch (err) {
      console.error("Failed to fetch completed calibration log books page:", err);
      set((s) => ({
        calibrationLogsList: {
          ...s.calibrationLogsList,
          completed: {
            ...s.calibrationLogsList.completed,
            isLoading: false,
            error: err?.message || "Failed to load calibration log books",
          },
        },
      }));
      return { ok: false, error: err };
    }
  },

  resetCalibrationLogsList: () =>
    set({ calibrationLogsList: calibrationLogsListInitialState }),
});